import { FileSource } from "@/types";

import { axios } from "../axios.instance";

export type UploadVideoRequest = FormData;

export type UploadVideoResponse = FileSource;

export const uploadVideo = async (body: UploadVideoRequest): Promise<UploadVideoResponse> => {
  const { data } = await axios.post(`/files/video/upload`, body);

  return data;
};
